export default __webpack_public_path__ + "static/media/stayrunning.b829bbad.png";